import React, { Component } from 'react';
import config from '../../config';

export const WithMethods = (WrappedComponent) => { // eslint-disable-line
  return class AddressFormMethodsProxy extends Component {
    getAddress() {
      return $.get(
        `${config.localeApi}/addresses`,
        'json',
      );
    }
    deleteAddress(address) {
      const url = `${config.localeApi}/address/delete/${address.id}`;
      return $.ajax({
        url,
        type: 'DELETE'
      });
    }
    saveEditAddress(address) {
      let { id, ...payload } = address;
      return $.ajax({
        method: 'PUT',
        dataType: 'json',
        contentType: 'application/json',
        url: `${config.localeApi}/address/update/${id}`,
        data: JSON.stringify(payload)
      });
    }
    saveNewAddress(address) {
      return $.ajax({
        url: `${config.localeApi}/address/store/`,
        type: 'POST',
        dataType: 'json',
        contentType: 'application/json',
        jsonp: false,
        data: JSON.stringify(address),
      })
    }
    render() {
      return (
        <WrappedComponent className="h-100" {...this.props}
          saveEditAddress={this.saveEditAddress}
          saveNewAddress={this.saveNewAddress}
          deleteAddress={this.deleteAddress}
          getAddress={this.getAddress}
        />
      );
    }
  };
};



// WEBPACK FOOTER //
// ./src/Address/AddressApi.js